import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

export async function fetchDeliveryDateChangeRequest(requestId) {
  const axios = axiosInstanceWithoutLoader().primoLab;

  const { data } = await axios.get(`/clinic-deliveries/delivery-date-change-requests/${requestId}`);
  return data.data;
}
